/**
 * The realtime channel grammar, copied from `service/src/channels.ts` (the contract with the subscribe
 * proxy and `app.can_subscribe`, 0040). `channels.test.ts` pins the exact strings on this side.
 */

/** A load's own stream (transitions and documents of that load). */
export function loadChannel(loadId: string): string {
  return `entity:load#${loadId}`;
}

/** A carrier's board (every load of that carrier). */
export function carrierChannel(carrierId: string): string {
  return `entity:carrier#${carrierId}`;
}

/** A user's direct stream (the rejection notice to the load's dispatcher). */
export function userChannel(userId: string): string {
  return `user:${userId}`;
}
